"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getCropForUserPhotoLayer;
const UserPhotoLayer_1 = require("../../models/layers/UserPhotoLayer");
const constants_1 = require("../../utils/constants");
const imageCrop_1 = require("../../utils/imageCrop");
const numbers_1 = require("../../utils/numbers");
function getCropForUserPhotoLayer(printableSurface, layer, galleryId, galleryImageId, imageSize, workspaceRotatedForPrintable, previousModifications) {
  const wellWidth = printableSurface.width * (layer === null || layer === void 0 ? void 0 : layer.width);
  const wellHeight = printableSurface.height * (layer === null || layer === void 0 ? void 0 : layer.height);
  if (isNaN(wellWidth) || isNaN(wellHeight)) {
    throw new Error(`wellWidth or wellHeight could not be calculated. wellWidth: ${printableSurface.width} * ${layer === null || layer === void 0 ? void 0 : layer.width}, wellHeight: ${printableSurface.height} * ${layer === null || layer === void 0 ? void 0 : layer.height}`);
  }
  const cropAspectRatio = workspaceRotatedForPrintable ? (0, imageCrop_1.calcAspectRatio)(wellWidth, wellHeight) : (0, imageCrop_1.calcAspectRatio)(wellHeight, wellWidth);
  const rotation = workspaceRotatedForPrintable ? (0, numbers_1.clipFloatingPoint)(-Math.PI / 2) : 0;
  const crop = (0, imageCrop_1.generateMaxCrop)(printableSurface, layer, workspaceRotatedForPrintable ? imageSize.height : imageSize.width, workspaceRotatedForPrintable ? imageSize.width : imageSize.height);
  const projectImageData = {
    galleryId,
    galleryImageId,
    modifications: Object.assign(Object.assign({}, previousModifications || {}), {
      cropAspectRatio,
      rotation,
      crop,
      schemaVersion: constants_1.PINTURA_VERSION // Should match the current Pintura version
    })
  };

  const projectImageId = (0, UserPhotoLayer_1.generateProjectImageId)(projectImageData);
  return Object.assign(Object.assign({}, projectImageData), {
    projectImageId,
    imageData: imageSize
  });
}